import { SIZE } from 'app/ui-components/typography/PlayText/PlayText';
import React from 'react';
import { Byline, CaptionText, Heading, StyledCaption } from './Caption.styles';

const Caption = ({ byline, heading, subHeading }) => (
    <StyledCaption>
        {byline && <Byline as="span">{byline}</Byline>}
        {heading && <Heading>{heading}</Heading>}
        <CaptionText size={SIZE.LARGE}>{subHeading}</CaptionText>
    </StyledCaption>
);

export default Caption;
